import "intersection-observer"

//修复某些ios版本不支持平滑滚动
//@ts-ignore
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
